import React from 'react';
import styles from './CalendarSettingsModal.module.scss';
import CalendarSettingsContent from '../CalendarSettingsContent';

const CalendarSettingsModal = ({
  calendarProps: { startDay, daySettings, searchParams },
}) => {
  return (
    <div className={styles.settings_modal_container}>
      <CalendarSettingsContent
        startDay={startDay}
        daySettings={daySettings}
        searchParams={searchParams}
        variant="modal"
      />
    </div>
  );
};

export default CalendarSettingsModal;
